import React from 'react';

function Hero() {
    return (
        <div className="info-hero">
            <span className="info-eyebrow">Patient Resource</span>
            <h1 className="display-5">Foot Health Information</h1>
            <p className="fs-5">
                A quick guide to common foot, nail, and related conditions we see and treat — and how we can help.
            </p>
        </div>
    );
}

export default Hero;
